import { useState, useCallback } from 'react';
import type { Id } from '../../convex/_generated/dataModel'; // DEEP_IMPORT_JUSTIFIED: Convex generated dataModel lives outside src/

interface IDeleteTarget {
  id: Id<'companies'>;
  name: string;
}

export function useCompanyListDialogs() {
  const [isInviteOpen, setIsInviteOpen] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState<IDeleteTarget | null>(null);

  const openInvite = useCallback(() => setIsInviteOpen(true), []);
  const closeInvite = useCallback(() => setIsInviteOpen(false), []);

  const openDelete = useCallback((id: Id<'companies'>, name: string) => {
    setDeleteTarget({ id, name });
  }, []);
  const closeDelete = useCallback(() => setDeleteTarget(null), []);

  return {
    isInviteOpen,
    setIsInviteOpen,
    openInvite,
    closeInvite,
    deleteTarget,
    openDelete,
    closeDelete,
  };
}
